<template>
<div>
    <!-- Folder Card -->
    <sav-fold-card :title="'<b>' + (folderNumber || (open ? $t('mes_produits.produit.dossier.informations_dossier') : $t('mes_produits.produit.dossier.consulter'))) + '</b>'" v-model="open" :more-class="(!open ? 'hover:bg-gray-300 duration-200 cursor-pointer' : '') + ' border-1 border-gray-300'">
        <template v-slot:close>
            <div class="flex items-center justify-between">
                <div>
                    <h5 class="capitalize">
                        <b> {{folderNumber || (open ? $t('mes_produits.produit.dossier.informations_dossier') : $t('mes_produits.produit.dossier.consulter'))}} </b>
                    </h5>
                    <!-- <span class="block mb-1 text-xs font-light text-gray-500" v-if="state == 2 && data && data.date_fin">{{$t('mes_produits.produit.dossier.cloture_le_date', {date: dateFormat(data.date_fin)})}}</span> -->
                    <!-- <span class="block mb-1 text-xs font-light text-gray-500" v-if="state != 2 && data && data.request_date">{{$t('mes_produits.produit.dossier.demande_du_date', {date: dateFormat(data.request_date)})}}</span> -->
                </div>
                <i class="fas fa-angle-right"></i>
            </div>
        </template>
        <template v-slot:open>
            <hr class="my-3">
            <folder-card-content
            :id="id"
            :state="state"
            :status="status"
            :date-last-maj="dateLastMaj"
            :case-data="caseData"
            :product-data="productData"
            />
        </template>
    </sav-fold-card>
</div>
</template>

<script>
import FolderCardContent from './FolderCardContent.vue'

export default {
    components: {FolderCardContent},
    props: {
        id: {
            required: true
        },
        state: {
            required: true
        },
        status: {
            required: true
        },
        folderNumber: {
            required: true
        },
        dateLastMaj: {},
        caseData: {},
        productData: {}
    },

    data() {
        return {
            open: false,
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/companies/default/views/user/product/FolderCard.vue